module.exports = __webpack_public_path__ + "img/exe.56775215.png";